import React, { useRef, useEffect, useState } from "react";
import ReactDOM from 'react-dom/client';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation, Link } from "react-router-dom";
import SpeechReader from "./SpeechReader"; // Adjust path as needed
import HomePage from "./HomePage";
import CapitalQuiz from "./CapitalQuiz";
import StateMapQuiz from "./StateMapQuiz";
import BackHomeLink from "./BackHomeLink";

const NO_HEADER_ROUTES = ["/read", "/capitals", "/map-quiz", "/math"];

function HeaderImage() {
  const location = useLocation();
  if (NO_HEADER_ROUTES.includes(location.pathname)) return null;
  return (
    <img
      src="quiz-logo.png"
      alt="Quiz"
      style={{ width: "60%", maxWidth: 500, marginBottom: 16, borderRadius: 12, objectFit: "contain" }}
    />
  );
}


function RootShell() {
  return (
    <>
      <div className="app-content" align="center">
        <HeaderImage />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/math" element={<App />} />
          <Route path="/capitals" element={<CapitalQuiz />} />
          <Route path="/map-quiz" element={<StateMapQuiz />} />
          <Route path="/read" element={<SpeechReader />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </div>
      <Footer />
    </>
  );
}

function getRandomInt(max) {
  return Math.floor(Math.random() * max) + 1;
}

function computeResult(numbers, operation) {
  switch (operation) {
    case "add":
    case "add_decimal":
      return numbers.reduce((a, b) => a + b, 0);
    case "sub":
    case "sub_decimal":
      return numbers.reduce((a, b) => a - b);
    case "mul":
      return numbers.reduce((a, b) => a * b, 1);
    case "div":
      return numbers.reduce((a, b) => a / b);
    case "div_rem": {
      const [dividend, divisor] = numbers;
      return {
        quotient: Math.floor(dividend / divisor),
        remainder: dividend % divisor
      };
    }
    default:
      return 0;
  }
}

function getOpSymbol(operation) {
  switch (operation) {
    case "add": return "+";
    case "add_decimal": return "+";
    case "sub": return "-";
    case "sub_decimal": return "-";
    case "mul": return "×";
    case "div": return "÷";
    case "div_rem": return "÷";
    default: return "+";
  }
}

   function getRandomNumber(max, allowDecimal = false) {
      if (allowDecimal) {
        return +(Math.random() * max + 1).toFixed(2);
      }
      return Math.floor(Math.random() * max) + 1;
    }

function AdditionPractice({ n, timeout, onNext, onComplete, max, operation }) {
  const [numbers] = useState(() => {
    if (operation === "div" || operation === "div_rem") {
      let divisor = getRandomInt(max);
      let result = getRandomInt(max);
      let dividend = divisor * result + (operation === "div_rem" ? getRandomInt(divisor - 1) : 0);
      return [dividend, divisor];
    }
    const allowDecimal = operation === "add_decimal" || operation === "sub_decimal";
    return Array.from({ length: n }, () => getRandomNumber(max, allowDecimal));
  });
  const [quotient, setQuotient] = useState("");
  const [remainder, setRemainder] = useState("");

  const [answer, setAnswer] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [timer, setTimer] = useState(timeout);
  const [timeoutError, setTimeoutError] = useState(false);
  const opSymbol = getOpSymbol(operation);
  const computedAnswer = computeResult(numbers, operation);
    const correctAnswer = operation === "div_rem"
      ? `${computedAnswer.quotient},${computedAnswer.remainder}`
      : (typeof computedAnswer === "number" && !Number.isInteger(computedAnswer) ? computedAnswer.toFixed(2) : computedAnswer);

  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [numbers]);

  useEffect(() => {
    if (timer > 0 && !submitted) {
      const id = setTimeout(() => setTimer(timer - 1), 1000);
      return () => clearTimeout(id);
    }
    if (timer === 0 && !submitted) {
      setSubmitted(true);
      setTimeoutError(true);
      setTimeout(() => {
        setTimeoutError(false);
        onComplete && onComplete({
          numbers,
          userAnswer: answer,
          correctAnswer,
          operation
        });
      }, 1000);
    }
  }, [timer, submitted, answer, numbers, correctAnswer, operation, onComplete]);

const handleSubmit = (e) => {
  e.preventDefault();
  setSubmitted(true);
  let userAnswer = answer;
  if (operation === "div_rem") {
    userAnswer = `${quotient},${remainder}`;
  }
  onComplete && onComplete({
    numbers,
    userAnswer,
    correctAnswer,
    operation
  });
};

  return (
    <div>
      <div>
        {numbers.join(` ${opSymbol} `)}
      </div>
      {operation === "div_rem" && (
        <div style={{ margin: "8px 0" }}>
          <label>
            Quotient:
            <input
                type="text"
                              inputMode="decimal"
              value={quotient}
              onChange={e => setQuotient(e.target.value)}
              disabled={submitted || timer === 0}
              style={{ width: 60, marginRight: 8 }}
            />
          </label>
          <label>
            Remainder:
            <input
                  type="text"
                                inputMode="decimal"
              value={remainder}
              onChange={e => setRemainder(e.target.value)}
              disabled={submitted || timer === 0}
              style={{ width: 60 }}
            />
          </label>
        </div>
      )}
      {operation === "sub_decimal" && (
        <form onSubmit={handleSubmit}>

           <button
             type="button"
             onClick={() => setAnswer(a => a.startsWith("-") ? a.slice(1) : "-" + a)}
             disabled={submitted || timer === 0}
             tooltip="Toggle positive/negative"
             title="Toggle positive/negative"> + / -
           </button>
           <input
             ref={inputRef}
             type="text"
             inputMode="decimal"
             pattern="-?[0-9]*[.,]?[0-9]*"
             value={answer}
             onChange={e => setAnswer(e.target.value)}
             disabled={submitted || timer === 0}
             style={{ width: 120 }}
           />
            &nbsp;
          <button type="submit" disabled={submitted || timer === 0}>
            Submit
          </button>
        </form>
      )}

      {(operation !== "div_rem" && operation !== "sub_decimal" ) && (
              <form onSubmit={handleSubmit}>
                <input
                  ref={inputRef}
                  type="text"
                  inputMode="decimal"
                   pattern="-?[0-9]*[.,]?[0-9]*" // <-- allow optional minus
                  value={answer}
                  onChange={e => setAnswer(e.target.value)}
                  disabled={submitted || timer === 0}
                   style={{ width: 120 }}
                />
                  &nbsp;
                <button type="submit" disabled={submitted || timer === 0}>
                  Submit
                </button>
              </form>
            )}

      {operation === "div_rem" && (
        <form onSubmit={handleSubmit}>
          <button type="submit" disabled={submitted || timer === 0}>
            Submit
          </button>
        </form>
      )}
      {timeoutError && (
        <div style={{ color: "red", marginTop: "8px" }}>
          Time's up
        </div>
      )}
      {!timeoutError && (
        <div>Time left: {timer}s </div>
      )}
    </div>
  );
}

function Footer() {
  return (
    <div align="center" style={{ marginTop: 24, color: "#1976d2" }}>
      &copy; {new Date().getFullYear()} All rights reserved.
      <span style={{ marginLeft: 16 }}>
        <a
          href="mailto:selva.mithil@gmail.com?subject=Math%20Practice%20Feedback"
          style={{
            color: "#1976d2",
            textDecoration: "underline",
            fontWeight: 600,
            marginLeft: 3
          }}
        >
        Contact Us
        </a>
      </span>
    </div>
  );
}

function App() {

  const [step, setStep] = useState(0);
  const [questions, setQuestions] = useState(3);
  const [n, setN] = useState(2);
  const [max, setMax] = useState(10);
  const [timeout, setTimeoutValue] = useState(10);
  const [current, setCurrent] = useState(0);
  const [results, setResults] = useState([]);
  const [operation, setOperation] = useState("add");
  const restartBtnRef = useRef(null);
  const stepBtnRef = useRef(null);

  useEffect(() => {
    if (current >= questions && restartBtnRef.current) {
      restartBtnRef.current.focus();
    }
    if (step === 0) {
      stepBtnRef.current.focus();
    }
  }, [current, questions, step]);

  const handleComplete = (data) => {
    setResults(prev => [...prev, data]);
    setCurrent(current + 1);
  };

  if (step === 0) {
    return (
      <div>
        <BackHomeLink />
        <h2>Math Quiz</h2>
        <label>
          Operation:
          <select value={operation} onChange={e => setOperation(e.target.value)} style={{ width: "200px" }}>
            <option value="add">Addition (+)</option>
            <option value="add_decimal">Addition with decimal (+)</option>
            <option value="sub">Subtraction (-)</option>
            <option value="sub_decimal">Subtraction with decimal (-)</option>
            <option value="mul">Multiplication (×)</option>
            <option value="div">Division (÷)</option>
            <option value="div_rem">Division with remainder (÷, %)</option> {/* New option */}
          </select>
        </label>
        <br />
        <label>
          Number of Questions:
          <input type="number" value={questions} onChange={e => setQuestions(Number(e.target.value))} />
        </label>
        <br />
        <label>
          Maximum Number Value (1 to max):
          <input type="number" value={max} onChange={e => setMax(Number(e.target.value))} />
        </label>
        <br />
        <label>
          Numbers to Use (N):
          <input
            type="number"
            value={n}
            min={operation === "div" ? 2 : 2}
            max={operation === "div" ? 2 : 10}
            onChange={e => setN(Number(e.target.value))}
            disabled={operation === "div"}
          />
        </label>
        <br />
        <label>
          Timeout (seconds):
          <input type="number" value={timeout} onChange={e => setTimeoutValue(Number(e.target.value))} />
        </label>
        <br />
        <button ref={stepBtnRef} onClick={() => setStep(1)}>Start</button>
      </div>
    );
  }

  if (current < questions) {
    return (
      <AdditionPractice
        key={current}
        n={operation === "div" ? 2 : n}
        timeout={timeout}
        onComplete={handleComplete}
        max={max}
        operation={operation}
      />
    );
  }

  const correctCount = results.filter(r => {
    if (r.operation === "div_rem") {
      return String(r.userAnswer).replace(/\s/g, "") === String(r.correctAnswer);
    }
    return String(r.userAnswer) === String(r.correctAnswer);
  }).length;
  const incorrectCount = results.length - correctCount;

  return (
    <div>
      <h2>All questions completed!</h2>
      <h3>Report:</h3>
      <ul>
        {results.map((r, i) => {
          const isCorrect = String(r.userAnswer) === String(r.correctAnswer);
          return (
            <li key={i}>
              Q{i + 1}:  {r.numbers.map(num => (typeof num === "number" && !Number.isInteger(num) ? num.toFixed(2) : num)).join(`${getOpSymbol(r.operation)} `)}  = {r.correctAnswer} |

              Your answer: {r.userAnswer || "No answer (timeout)"}{" "}
              {r.userAnswer
                ? (isCorrect ? <span style={{ color: "green" }}>✔️</span> : <span style={{ color: "red" }}>❌</span>)
                : null}
            </li>
          );
        })}
      </ul>
      <div>
        <strong>Correct answers:</strong> {correctCount} <span style={{ color: "green" }}>✔️</span>
        <br />
        <strong>Incorrect answers:</strong> {incorrectCount} <span style={{ color: "red" }}>❌</span>
        <br /><br />
        <button
          ref={restartBtnRef}
          onClick={() => {
            setStep(0);
            setCurrent(0);
            setResults([]);
          }}>
          Restart
        </button>
        &nbsp;
        <Link to="/" className="back-home-btn">
          &#8592; Home
        </Link>
      </div>
    </div>
  );
}

//const root = ReactDOM.createRoot(document.getElementById('root'));
//root.render(
//  <React.StrictMode>
//
//    <div className="app-content" align="center">
//     <img
//            src="pageheader1.jpg"
//            alt="Math Practice"
//            style={{ width: "60%", maxWidth: 500, marginBottom: 16, borderRadius: 12 }}
//          />
//      <App />
//
//    </div>
//    <Footer />
//  </React.StrictMode>
//);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <RootShell />
    </BrowserRouter>
  </React.StrictMode>
);
